import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CalendarCheck } from "lucide-react";
import { scrollToEl } from "@/lib/scroll";

// Always-visible "Book Free Consult" bar on mobile/tablet.
export default function StickyConsult() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const consult = document.querySelector("#consult");
      const past = window.scrollY > window.innerHeight * 0.6;
      // hide once the consult form itself is on screen
      const nearForm = consult && consult.getBoundingClientRect().top < window.innerHeight * 0.9;
      setShow(past && !nearForm);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="lg:hidden fixed bottom-0 left-0 right-0 z-40 p-3 bg-black/80 backdrop-blur-xl border-t border-white/10"
          data-testid="sticky-consult"
        >
          <button
            onClick={() => scrollToEl("#consult")}
            className="w-full font-mono-accent text-xs bg-[#005EEA] text-white py-4 flex items-center justify-center gap-2 hover:bg-[#0047b3] transition-colors shadow-[0_0_30px_rgba(0,94,234,0.4)]"
            data-testid="sticky-consult-btn"
          >
            <CalendarCheck size={15} /> Book Free Consult
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
